import React, {
  useState,
  useEffect,
  useReducer,
  useCallback,
  useContext,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
// import MessageModal from "../../components/MessageModal"
import ScheduleModal from "../../components/ScheduleModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import PageHelpGuide from "../../components/PageHelpGuide";
import { SCHEDULES_HELP_DATA } from "../../constants/pageHelp/schedulesHelp";
import moment from "moment";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "moment/locale/pt-br";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import SearchIcon from "@material-ui/icons/Search";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import { getStandardButtonStyles } from "../../styles/standardButtons";

import "./Schedules.css"; // Importe o arquivo CSS

// Defina a função getUrlParam antes de usá-la
function getUrlParam(paramName) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
}

// Estilos movidos a Schedules.css para mayor flexibilidad

const localizer = momentLocalizer(moment);



const reducer = (state, action) => {
  if (action.type === "LOAD_SCHEDULES") {
    const schedules = action.payload;
    const newSchedules = [];

    schedules.forEach((schedule) => {
      const scheduleIndex = state.findIndex((s) => s.id === schedule.id);
      if (scheduleIndex !== -1) {
        state[scheduleIndex] = schedule;
      } else {
        newSchedules.push(schedule);
      }
    });

    return [...state, ...newSchedules];
  }

  if (action.type === "UPDATE_SCHEDULES") {
    const schedule = action.payload;
    const scheduleIndex = state.findIndex((s) => s.id === schedule.id);

    if (scheduleIndex !== -1) {
      state[scheduleIndex] = schedule;
      return [...state];
    } else {
      return [schedule, ...state];
    }
  }

  if (action.type === "DELETE_SCHEDULE") {
    const scheduleId = action.payload;

    const scheduleIndex = state.findIndex((s) => s.id === scheduleId);
    if (scheduleIndex !== -1) {
      state.splice(scheduleIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 16,
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32 !important" : theme.palette.background.paper,
  },
  cyanButton: {
    backgroundColor: '#00b0ff',
    color: '#fff',
    borderRadius: '4px',
    textTransform: 'none',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#0091ea',
      boxShadow: '0 4px 12px rgba(0, 176, 255, 0.4)',
      transform: 'translateY(-2px)'
    },
    '&:active': {
      transform: 'translateY(0)',
      boxShadow: 'none'
    }
  },

  scrollArea: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  calendarToolbar: {
    "& .rbc-toolbar-label": {
      color: theme.palette.type === "dark" ? "#FFF" : "#000",
    },
    "& .rbc-btn-group button": {
      color: theme.palette.type === "dark" ? "#FFF" : "#000",
      "&:hover": {
        color: theme.palette.type === "dark" ? "#FFF" : "#000",
      },
      "&:active": {
        color: theme.palette.type === "dark" ? "#FFF" : "#000",
      },
      "&:focus": {
        color: theme.palette.type === "dark" ? "#FFF" : "#000",
      },
      "&.rbc-active": {
        color: theme.palette.type === "dark" ? "#FFF" : "#000",
      },
    },
  },
}));

const Schedules = () => {
  const classes = useStyles();
  const history = useHistory();

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [deletingSchedule, setDeletingSchedule] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [schedules, dispatch] = useReducer(reducer, []);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactId, setContactId] = useState(+getUrlParam("contactId"));

  const { getPlanCompany } = usePlans();

  const messages = React.useMemo(() => ({
    date: i18n.t("schedules.date"),
    time: i18n.t("schedules.time"),
    event: i18n.t("schedules.event"),
    allDay: i18n.t("schedules.allDay"),
    week: i18n.t("schedules.week"),
    work_week: i18n.t("schedules.work_week"),
    day: i18n.t("schedules.day"),
    month: i18n.t("schedules.month"),
    previous: i18n.t("schedules.previous"),
    next: i18n.t("schedules.next"),
    yesterday: i18n.t("schedules.yesterday"),
    tomorrow: i18n.t("schedules.tomorrow"),
    today: i18n.t("schedules.today"),
    agenda: i18n.t("schedules.agenda"),
    noEventsInRange: i18n.t("schedules.noEventsInRange"),
    showMore: (total) => `+${total} ${i18n.t("schedules.more")}`,
  }), [i18n.language]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useSchedules) {
        toast.error(
          i18n.t("toastError.permissionDenied")
        );
        setTimeout(() => {
          history.push(`/`);
        }, 1000);
      }
    }
    fetchData();
  }, [user, history, getPlanCompany]);

  useEffect(() => {
    document.title = i18n.t("schedules.title");
  }, [i18n.language]);

  useEffect(() => {
    const lng = i18n.language;
    if (lng === "pt") moment.locale("pt-br");
    else if (lng === "en") moment.locale("en-gb");
    else if (lng === "fr") moment.locale("fr");
    else if (lng === "ar") moment.locale("ar");
    else moment.locale("es");
  }, [i18n.language]);

  const fetchSchedules = useCallback(async () => {
    try {
      const { data } = await api.get("/schedules", {
        params: { searchParam, pageNumber },
      });

      dispatch({ type: "LOAD_SCHEDULES", payload: data.schedules });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  }, [searchParam, pageNumber]);

  const handleOpenScheduleModalFromContactId = useCallback(() => {
    if (contactId) {
      handleOpenScheduleModal();
    }
  }, [contactId]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchSchedules();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    contactId,
    fetchSchedules,
    handleOpenScheduleModalFromContactId,
  ]);

  useEffect(() => {
    // handleOpenScheduleModalFromContactId();
    // const socket = socketManager.GetSocket(user.companyId, user.id);

    const onCompanySchedule = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_SCHEDULES", payload: data.schedule });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_SCHEDULE", payload: +data.scheduleId });
      }
    };

    socket.on(`company${user.companyId}-schedule`, onCompanySchedule);

    return () => {
      socket.off(`company${user.companyId}-schedule`, onCompanySchedule);
    };
  }, [socket]);

  const cleanContact = () => {
    setContactId("");
  };

  const handleOpenScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(true);
  };

  const handleCloseScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditSchedule = (schedule) => {
    setSelectedSchedule(schedule);
    setScheduleModalOpen(true);
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await api.delete(`/schedules/${scheduleId}`);
      toast.success(i18n.t("schedules.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingSchedule(null);
    setSearchParam("");
    setPageNumber(1);

    dispatch({ type: "RESET" });
    setPageNumber(1);
    await fetchSchedules();
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const truncate = (str, len) => {
    if (str.length > len) {
      return str.substring(0, len) + "...";
    }
    return str;
  };

  const CustomEvent = ({ event }) => {
    return (
      <div className="event-container">
        <div className="event-time">
          {moment(event.start).format("HH:mm")}
        </div>
        <div className="event-title">{event.contact?.name}</div>
        <Tooltip title={i18n.t("schedules.buttons.delete")}>
          <DeleteOutlineIcon
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteSchedule(event.id);
            }}
            className="delete-icon"
          />
        </Tooltip>
        <Tooltip title={i18n.t("schedules.buttons.edit")}>
          <EditIcon
            onClick={(e) => {
              e.stopPropagation();
              handleEditSchedule(event);
              setScheduleModalOpen(true);
            }}
            className="edit-icon"
          />
        </Tooltip>
      </div>
    );
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={
          deletingSchedule &&
          `${i18n.t("schedules.confirmationModal.deleteTitle")}`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteSchedule(deletingSchedule.id)}
      >
        {i18n.t("schedules.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {scheduleModalOpen && (
        <ScheduleModal
          open={scheduleModalOpen}
          onClose={handleCloseScheduleModal}
          reload={fetchSchedules}
          // aria-labelledby="form-dialog-title"
          scheduleId={selectedSchedule ? selectedSchedule.id : null}
          contactId={contactId}
          cleanContact={cleanContact}
          user={user}
        />
      )}
      <Paper
        className={classes.mainPaper}
        variant="outlined"
      >
        <MainHeader>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <PageHelpGuide
              helpData={SCHEDULES_HELP_DATA}
              tooltipText="Guía y Ayuda de Recordatorios (Haz clic para ver)"
            />
            <Title>
              {i18n.t("schedules.title")} ({schedules.length})
            </Title>
          </div>
          <MainHeaderButtonsWrapper>
            <TextField
              placeholder={i18n.t("contacts.searchPlaceholder")}
              type="search"
              value={searchParam}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="secondary" />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              className={classes.applyButton}
              onClick={handleOpenScheduleModal}
            >
              {i18n.t("schedules.buttons.add")}
            </Button>
          </MainHeaderButtonsWrapper>
        </MainHeader>
        <div className={classes.scrollArea} onScroll={handleScroll}>
        <div className="schedule-legend-container">
          <div className="legend-item">
            <div className="legend-color pending"></div>
            <span>{i18n.t("schedules.legend.pending")}</span>
          </div>
          <div className="legend-item">
            <div className="legend-color waiting-reminder"></div>
            <span>{i18n.t("schedules.legend.waitingReminder")}</span>
          </div>
          <div className="legend-item">
            <div className="legend-color sent"></div>
            <span>{i18n.t("schedules.legend.sent")}</span>
          </div>
        </div>
        <Calendar
          messages={messages}
          formats={{
            agendaDateFormat: "DD/MM ddd",
            weekdayFormat: "dddd",
          }}
          localizer={localizer}
          events={schedules.map((schedule) => ({
            ...schedule,
            title: schedule.contact?.name || "",
            start: new Date(schedule.sendAt),
            end: new Date(schedule.sendAt),
          }))}
          components={{
            event: CustomEvent,
          }}
          eventPropGetter={(event) => {
            const status = event.status?.toUpperCase() || "";
            let className = "";

            if (status === "ENVIADO" || status === "SENT" || status === "ENVIADA" || status === "ERRO" || status === "CANCELADO") {
              className = "schedule-sent"; // Rojo
            } else if (status === "AGUARDANDO_LEMBRETE") {
              className = "schedule-waiting-reminder"; // Naranja
            } else {
              className = "schedule-pending"; // Verde
            }

            return { className };
          }}
          startAccessor="start"
          endAccessor="end"
          tooltipAccessor={() => ""}
          style={{ height: 500 }}
          className={classes.calendarToolbar}
        />
        </div>
      </Paper>
    </MainContainer>
  );
};

export default Schedules;
